import * as S from '@effect/schema/Schema';
import * as t from 'io-ts';
export var ProfilePageQuery = t.type({
  profile: t.type({
    id: t.string,
    isAdmin: t["boolean"]
  })
});
export var ProfilePageBlockConfig = S.struct({
  typename: S.literal('ProfilePageBlock'),
  id: S.string,
  hash: S.string,
  messagingEnabled: S["boolean"],
  langSelectorEnabled: S["boolean"]
});